module.exports = __webpack_public_path__ + "img/ordPrimer2.ce2745e1.jpg";